<template>
  <div class="batchBox">
    <div class="backBox">
      <span class="goback" v-if="activeIndex === 0||activeIndex === 1" @click="goToTable">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-fanhui"></use>
        </svg>
        返回</span>
      <span v-if="activeIndex === 3" class="goback" @click="goToTable">
      <span class="iconfont">&#xe602;</span>完成</span>
    </div>
    <div class="batchBoxTitle">{{ title }}</div>
    <div class="batchSteps" v-if="loginInfo.userType==1">
      <div :class="activeIndex == 0? 'active':''" class="batchStep">
        <div class="stepIndex">1</div>
        <span>选择公司</span>
      </div>
      <div :class="activeIndex == 1? 'active':''" class="batchStep">
        <div class="stepIndex">2</div>
        <span>上传文件</span>
      </div>
      <div :class="activeIndex == 2? 'active':''" class="batchStep">
        <div class="stepIndex">3</div>
        <span>导入完成</span>
      </div>
    </div>
    <div class="batchSteps" v-else>
      <div :class="activeIndex == 0? 'active':''" class="batchStep">
        <div class="stepIndex">1</div>
        <span>上传文件</span>
      </div>
      <div :class="activeIndex == 1? 'active':''" class="batchStep">
        <div class="stepIndex">2</div>
        <span>导入完成</span>
      </div>
    </div>
    <template v-if="loginInfo.userType==1">
      <step1 v-if="activeIndex === 0" @next="addstep"/>
      <step2 v-if="activeIndex === 1" :type-id="typeId" :cus-id="cusId" @onupload="addstep"/>
      <step3 v-else-if="activeIndex === 2" @next="goToTable" />
    </template>
    <template v-else>
      <step2 v-if="activeIndex === 0" :type-id="typeId" cus-id="" @onupload="addstep"/>
      <step3 v-else-if="activeIndex === 1" @next="goToTable" />
    </template>
  </div>
</template>
<script>
import step1 from './step1'
import step2 from './step2'
import step3 from './step3'
import {mapGetters} from "vuex";
export default {
  components: { step1,step2, step3 },
  data() {
    return {
      activeIndex: 0,
      typeId: '',
      title: '导入人员',
      cusId:'' //客户id
    }
  },
  mounted() {
    // 加载参数
    //this.typeId = this.$route.params.typeId
    //console.log(this.typeId)
    //if (this.typeId === '1') {
      //this.title = '批量增员'
   // } else {
      //this.title = ''
    //}
  },
  computed: {
    ...mapGetters([ "loginInfo"])
  },
  methods: {
    // 下一步
    addstep(cusId) {
      this.activeIndex = this.activeIndex + 1
      this.cusId = cusId
      console.log("cusId:"+cusId)
    },
    goback() {
      this.activeIndex = this.activeIndex - 1
    },
    goToTable() {
      if(this.activeIndex==0){
        // 返回数据页面
        this.$router.go(-1)
      }else {
        this.goback()
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .backBox{
    /*margin-bottom: 20px;*/
  }
  .goback{
    width: 70px;
    padding:8px;
    border:1px solid #cccccc;
    color:#cccccc;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    line-height: 16px;
    font-size: 14px;
    cursor: pointer;
  }
  .goback:hover{
    border:1px solid #269cff;
    color:#269cff;
  }
  .batchBoxTitle{
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }

</style>
